import React from 'react'
import { Button, CircularProgress } from '@mui/material'

const CommonButton = (props) => {
  const { type, onClick, buttonName, fullWidth, variant, color, size, startIcon, endIcon, disabled, style, className, loading } = props
  return (
    <>
      <Button
        type={type || "button"}
        variant={variant ? variant : "contained"}
        color={color ? color : 'primary'}
        size={size ? size : "medium"}
        onClick={onClick}
        fullWidth={fullWidth}
        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
        endIcon={endIcon}
        disabled={disabled || loading}
        sx={style}
        className={className}
      >
        {loading ? "Please wait..." : buttonName}
      </Button>
    </>
  )
}

export default CommonButton